<template>
  <div class="c-commentReply">
    <div
      class="c-commentReplyCollapse"
      v-if="!expanded"
      @click="expanded = true"
    >
      出品者からの返信を読む
      <coconala-icon
        name="chevron-down"
        size="11px"
      />
    </div>
    <div
      class="c-commentReplyExpanded"
      v-if="expanded && !ratingReply.deleteFlag"
    >
      <div class="c-commentReplyExpanded_icon">
        <c-user-icon-v2
          :file-path="ratingReply.provider.icon"
          :user-name="ratingReply.provider.name"
          :size="24"
        />
      </div>
      <div class="c-commentReplyExpanded_comment">
        <div class="c-commentReplyCommentRow">
          <a
            :href="'/users/' + ratingReply.provider.id"
            target="_blank"
            rel="noopener"
            class="c-commentReplyCommentRow_name"
          >
            {{ ratingReply.provider.name }}
          </a>
        </div>
        <div class="c-commentReplyCommentRow">
          <div class="c-commentReplyCommentRow_comment">
            <div v-text="ratingReply.comment"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="c-commentReplyExpanded c-commentReplyExpanded-delete"
      v-else-if="expanded && ratingReply.deleteFlag"
    >不適切な内容が含まれていたため、運営にてコメントを削除いたしました。不適切な内容についての詳細は<a
        :href="$coconala.helpURL('/articles/360010558453')"
        target="_blank"
      >こちら</a>
    </div>
  </div>
</template>
<script>
// vuex
import { mapGetters } from 'vuex'

export default {
  name: 'RatingCommentReply',
  props: {
    ratingReply: {
      type: Object,
      default: () => ({
        comment: '',
        created: 0,
        deleteFlag: false,
        id: 0,
        provider: {}
      })
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP'])
  }
}
</script>
<style lang="scss" scoped>
.c-commentReply {
  margin-top: 16px;
}

.c-commentReplyCollapse {
  @include link-effect;
  color: $color-blue-500;
  font-size: 13px;
  margin-left: 60px;
  cursor: pointer;
}

.c-commentReplyExpanded {
  display: flex;
  margin-left: 60px;

  &-delete {
    display: block;
  }

  &_icon {
    margin-right: 12px;
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    overflow: hidden;
  }

  &_comment {
    flex: 1 1 auto;
  }
}

.c-commentReplyCommentRow {
  &_comment {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}

@media (max-width: breakpoint(ServiceDetail, M)) {
  .c-commentReplyExpanded {
    margin-left: 0;
  }

  .c-commentReplyCollapse {
    margin-left: 0;
  }
}
</style>
